export const Branding: Branding = {
    primary: "#2a9fd6",
    transparentBackground: "rgba(0,0,0,0.75)",
    transparentGreyBackground: "rgba(40,40,40,0.75)"
};

export default Branding;